<template>
  <div class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form autocomplete="off">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required|alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              ref="userFirstName"
              class="w-full"
              placeholder="First Name"
              label-placeholder="First Name"
              name="employeeFirstName"
              v-model="frm.employeeFirstName"
              autocomplete="nope"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('employeeFirstName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("employeeFirstName") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('employeeFirstName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Last Name"
              label-placeholder="Last Name"
              name="employeeLastName"
              v-model="frm.employeeLastName"
              autocomplete="nope"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('employeeLastName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("employeeLastName") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('employeeLastName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'email|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Email"
              label-placeholder="Email"
              name="employeeEmail"
              v-model="frm.employeeEmail"
              autocomplete="nope"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('employeeEmail')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("employeeEmail") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('employeeEmail')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required|decimal:10'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Mobile No"
              label-placeholder="Mobile No"
              name="employeeMobileNo"
              v-model="frm.employeeMobileNo"
              autocomplete="nope"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('employeeMobileNo')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("employeeMobileNo") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('employeeMobileNo')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-textarea
              counter="500"
              label="Address"
              :counter-danger.sync="counterDanger"
              v-model="frm.employeeAddress"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              class="Location"
              label="Location"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Locations"
              label-placeholder="vs-Multiple"
              v-model="frm.locationId"
              width="100%"
              autocomplete
              @change="locationChanges($event)"
            >
              <vs-select-item
                :key="index"
                :value="item.locationId"
                :text="item.locationName"
                v-for="(item, index) in locations"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('locationId')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("locationId") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('locationId')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              autocomplete
              class="Branch"
              label="Branch"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Branch"
              label-placeholder="vs-Multiple"
              name="branchId"
              v-model="frm.branchId"
              icon="arrow_downward"
              width="100%"
            >
              <vs-select-item
                :key="index"
                :value="item.branchId"
                :text="item.branchName"
                v-for="(item, index) in filterBranch"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('branchId')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("branchId") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('branchId')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              class="Designation"
              label="Designation"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Designation"
              label-placeholder="vs-Multiple"
              v-model="frm.designationId"
              width="100%"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item.designationId"
                :text="item.designationText"
                v-for="(item, index) in designations"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('locationId')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("locationId") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('locationId')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <span class="digitelex-overflow-label-container">
              <label class="digitelex-overflow-label">Create Credetials</label>
              <vx-tooltip
                position="bottom"
                text="By enabling it create the logins for employee"
              >
                <vs-button
                  size="small"
                  radius
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
            <vs-switch v-model="enableUserCredentials">
              <span slot="on">Yes</span>
              <span slot="off">No</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row" v-if="enableUserCredentials">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              :disabled="frm.employeeId!=0"
              data-vv-validate-on="input|keyup|blur|click"
              ref="userName"
              required
              class="w-full"
              placeholder="User Name"
              label-placeholder="User Name"
              name="userName"
              v-model="frm.userName"
              autocomplete="nope"
            />

            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('userName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("userName") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('userName')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Password</label>

            <vx-input-group>
              <vs-input
                data-vv-validate-on="input|keyup|blur|click"
                class="w-full"
                placeholder="Password"
                name="password"
                v-model="frm.password"
                autocomplete="nope"
                :type="showPassword ? 'text' : 'password'"
                ref="password"
              />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary" @click="toogle">
                    {{ showPassword ? "Hide" : "Show" }}
                  </vs-button>
                </div>
              </template>
            </vx-input-group>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('employeeLastName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("employeeLastName") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('employeeLastName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row" v-if="enableUserCredentials">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              class="roles"
              label="Role"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Role"
              label-placeholder="vs-Multiple"
              v-model="frm.role"
              width="100%"
              autocomplete
            >
              <vs-select-item
                v-for="(item, index) in roles"
                :key="index"
                :value="item.roleId"
                :text="item.roleName"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('roles')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("roles") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('roles')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2" v-if="accessProfiles">
            <vs-select
              class="accessprofiles"
              label="Access Profiles"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Access Profiles"
              v-model="frm.accessProfilesArray"
              width="100%"
              max-selected="5"
              multiple
              autocomplete
            >
              <vs-select-item
                v-for="(item, index) in accessProfiles"
                :key="index"
                :value="item.accessProfileId"
                :text="item.accessProfileName"
              />
            </vs-select>
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('roles')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("roles") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('roles')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>

        <div class="flex flex-wrap justify-end">
          <vs-button
            :disabled="!validateForm"
            @click="saveEmployee"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <vs-button class="ml-4" type="border" color="warning"
            >Cancel</vs-button
          >
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};
Validator.localize("en", dict);
export default {
  props: {
    frmData: {},
  },
  components: {},
  methods: {
    locationChanges(_e) {
      this.filterBranch = this.branches.filter((data) => data.locationId == _e);
    },
    toogle() {
      this.passwordType = this.passwordType ? "password" : "text";
      this.showPassword = !this.showPassword;
    },

    getLocations() {
      this.$http.get("common/locations").then((response) => {
        this.locations = response.data.data;
        this.getBranches();
      });
    },
    getRoles() {
      this.$http.get("common/roles").then((response) => {
        this.roles = response.data.data;
      });
    },
    getAccessProfiles() {
      this.$http.get("common/accessProfiles").then((response) => {
        this.accessProfiles = response.data.data;
        console.log(this.accessProfiles);
        console.log(this.frm);
      });
    },
    getBranches() {
      this.$http.get("common/branches").then((response) => {
        this.branches = response.data.data;
        this.filterBranch = this.branches;
        this.getDesginations();
      });
    },
    getDesginations() {
      this.$http.get("common/designationEnum").then((response) => {
        this.designations = response.data.data;
        this.getRoles();
      });
    },
    saveEmployee() {
      if (this.frm.employeeId && this.frm.employeeId != 0) {
        let employeeResponse = [];
        let userResponse = [];

        this.frm.isActive = true;
        this.frm.viewEmployee = true;
        this.frm.viewUser = true;
        this.$http
          .put("core/employee", this.frm)
          .then((response) => {
            // this.frm.employeeId = response.data.employeeId;
            employeeResponse = response.data;
            if (
              this.enableUserCredentials &&
              this.frm.userId != null &&
              this.frm.userId != 0
            ) {
              this.$http.put("core/user", this.frm).then((response) => {
                userResponse = response.data;
                this.$http
                  .put(`core/userRole/${this.frm.userId}`, {
                    userRole: this.frm.role,
                    isActive: true,
                  })
                  .then((_response) => {
                    // console.log(response);
                    this.$http
                      .put(`core/userAccessProfile/${this.frm.userId}`, {
                        accessProfiles: this.frm.accessProfilesArray,
                        isActive: true,
                      })
                      .then((_response) => {
                        // console.log(response);
                        this.$emit("submitResponse", userResponse);
                      });
                  });
              });
            } else if (this.enableUserCredentials && this.frm.userName) {
              this.$http.post("core/user", this.frm).then((response) => {
                this.frm.userId = response.data.userId;
                userResponse = response.data;
                this.$http
                  .post(`core/userRole/${response.data.userId}`, {
                    userRole: this.frm.role,
                    isActive: true,
                  })
                  .then((_response) => {
                    // console.log(response);
                    this.$http
                      .post(`core/userAccessProfile/${this.frm.userId}`, {
                        accessProfiles: this.frm.accessProfilesArray,
                        isActive: true,
                      })
                      .then((_response) => {
                        // console.log(response);
                        this.$emit("submitResponse", userResponse);
                      });
                  });
              });
            } else {
              this.$emit("submitResponse", employeeResponse);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        let userResponse = [];
        let employeeResponse = [];
        this.frm.employeeId = 0;
        this.frm.userId = 0;
        this.frm.isActive = true;
        this.frm.viewEmployee = true;
        this.frm.viewUser = true;
        this.$http
          .post("core/employee", this.frm)
          .then((response) => {
            this.frm.employeeId = response.data.employeeId;
            employeeResponse = response.data;
            if (this.enableUserCredentials) {
              this.$http.post("core/user", this.frm).then((response) => {
                this.frm.userId = response.data.userId;
                userResponse = response.data;
                this.$http
                  .post(`core/userRole/${response.data.userId}`, {
                    userRole: this.frm.role,
                    isActive: true,
                  })
                  .then((_response) => {
                    // console.log(response);
                    this.$http
                      .post(`core/userAccessProfile/${this.frm.userId}`, {
                        accessProfiles: this.frm.accessProfilesArray,
                        isActive: true,
                      })
                      .then((_response) => {
                        // console.log(response);
                        this.$emit("submitResponse", userResponse);
                      });
                  });
              });
            } else {
              this.$emit("submitResponse", employeeResponse);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  data() {
    return {
      select1: [],
      select2: [],
      select3: [],
      options1: [
        { text: "IT", value: 0 },
        { text: "Blade Runner", value: 2 },
        { text: "Thor Ragnarok", value: 3 },
      ],
      options2: [
        { text: "Square", value: 1 },
        { text: "Rectangle", value: 2 },
        { text: "Rombo", value: 3 },
        { text: "Romboid", value: 4 },
        { text: "Trapeze", value: 5 },
        { text: "Triangle", value: 6 },
        { text: "Polygon", value: 7 },
        { text: "Regular polygon", value: 8 },
        { text: "Circumference", value: 9 },
        { text: "Circle", value: 10 },
        { text: "Circular sector", value: 11 },
        { text: "Circular trapeze", value: 12 },
      ],
      options3: [
        { text: "Red", value: 1 },
        { text: "Green", value: 2 },
        { text: "Blue", value: 3 },
        { text: "Purple", value: 4 },
      ],
      counterDanger: true,
      showPassword: false,
      passwordType: "password",
      enableUserCredentials: false,
      filterBranch: [],
      branches: [],
      locations: [],
      designations: [],
      accessProfiles: [
        { accessProfileName: "Branch Operator", accessProfileId: 2 },
        { accessProfileName: "Main", accessProfileId: 1 },
      ],
      roles: [],
      frm: {
        employeeFirstName: null,
        employeeLastName: null,
        userId: 0,
        branchId: 0,
        designationId: 0,
        employeeEmail: null,
        employeeId: 0,
        employeeMobileNo: null,
        employeePhoto: null,
        employeeUniq: null,
        locationId: 0,
        employeeAddress: null,
        isActive: null,
        userName: null,
        password: null,
        accessProfilesArray: [],
        role: null,
        viewEmployee: true,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        this.frm = after;
      },
      immediate: true,
    },
    enableUserCredentials: {
      handler(_before, _after) {
        // console.log(before);
        // console.log(after);
        // console.log(this.$refs);
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.frm.employeeFirstName != "" &&
        this.frm.employeeFirstName != null
      );
    },
  },
  beforeMount() {
    this.getAccessProfiles();

    this.getLocations();
    console.log(this.frmData);
    this.frm.accessProfilesArray = [];
    if (this.frm.userId) {
      this.enableUserCredentials = true;
      this.frm.role = this.frmData.roles.roleId;
      const accessprofiles = this.frmData.accessProfiles;
      this.frm.accessProfilesArray = accessprofiles.map((data) => {
        return data.accessProfileId;
      });
    }
    console.log(this.frm);
  },
};
</script>
